import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-makeup-transfer"
    path="business/products/ai-makeup-transfer"
    element={<AsyncPage />}
  />,
];
